@if (shouldShow) {
<button class="_back-button"
        (click)="goBack()"
        type="button"
        aria-label="Go back">
    <i class="icon-arrow-simple-left inline-flex"></i>
</button>
}
